import { selectCurrentEntitiesById } from 'ducks/entities/selectors'

export const selectPricingsById = state =>
  selectCurrentEntitiesById(state, 'pricing')
